import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

import Checkbox from '@components/Checkbox';
import CartItemDescription from '../CartItemDescription';
import CartItemPrice from '../CartItemPrice';
import Left from './components/Left';
import Center from './components/Center';
import Right from './components/Right';
import Title from './components/Title';
import Container from './components/Container';
import CardOverlay from '../CartQuantityCounter/components/CardOverlay';
import CheckboxContainer from './components/CheckboxContainer';

const noOp = () => {};

function CartItem({
  name,
  options,
  subtotal,
  subtotalNoDiscount,
  isEditing,
  isSelected,
  hasErrors,
  available,
  deleteEnabled,
  onDelete,
  onSelect,
  subsidizedProduct,
  requireValidation,
  isUpdatingLines,
  leftComponent,
}) {
  if (isEditing && (!onSelect || (deleteEnabled && !onDelete)))
    throw new Error('onSelect and onDelete are required for editing CartItem');

  const onSelectFn = isEditing ? onSelect : noOp;
  const [showOverlay, setShowOverlay] = useState(false);

  const overlayState = open => {
    setShowOverlay(open);
  };

  const cartEditionWithOutCounter = isEditing && deleteEnabled;

  return (
    <Container withWarning={requireValidation} align={false}>
      <Left id="left__cartitem" onClick={isEditing ? onDelete : noOp}>
        {cartEditionWithOutCounter ? (
          <CheckboxContainer>
            <Checkbox selected={isSelected} />
          </CheckboxContainer>
        ) : (
          leftComponent
        )}
      </Left>
      <Center
        id="center__cartitem"
        onClick={isUpdatingLines ? onSelectFn : onSelect}
        available={available}
      >
        <Title available={available}>{name}</Title>
        <CartItemDescription items={options} showErrors={hasErrors} />
      </Center>
      <Right onClick={onSelectFn}>
        {isUpdatingLines ? (
          <Skeleton height="15" width="80" />
        ) : (
          <CartItemPrice
            subtotal={subtotal}
            subtotalNoDiscount={subtotalNoDiscount}
            available={available}
            subsidizedProduct={subsidizedProduct}
          />
        )}
      </Right>
      {showOverlay && (
        <CardOverlay
          onClick={() => {
            overlayState(false);
          }}
        />
      )}
    </Container>
  );
}

CartItem.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  subtotal: PropTypes.number.isRequired,
  leftComponent: PropTypes.node,
  isEditing: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool,
  available: PropTypes.bool,
  subsidizedProduct: PropTypes.bool,
  deleteEnabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  subtotalNoDiscount: PropTypes.number.isRequired,
  requireValidation: PropTypes.bool,
  isUpdatingLines: PropTypes.bool,
};

CartItem.defaultProps = {
  options: [],
  hasErrors: false,
  available: true,
  deleteEnabled: true,
  isUpdatingLines: false,
};

export default CartItem;
